import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

//import api
import { getAssetData } from "../../api/walletAction";

//import component
import WalletDetails from "./WalletDetails";

const Wallet = () => {

  const dispatch = useDispatch()

  useEffect(() => {
    getAssetData(dispatch)
  }, [])

  return (
    <>
      <div className="">
       
         
            <WalletDetails />
         
      </div>
    </>
  );
};

export default Wallet;
